import VCFundApplication from './VCFundApplication';

export default VCFundApplication;
